import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import mouUniversal from '../../assets/mouLogo.png';
import Sidebar from './sidebar';
import UserPanel from './UserPanel';
import useAuth from '../../hooks/useAuth';

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/personas/iniciar-sesion" replace />;
  }

  return (
    <div className="relative flex min-h-screen bg-[#e8f2f4] pl-16">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <div className="flex justify-between items-center mb-4 ml-16">
          <button
            type="button"
            onClick={() => navigate('/personas')}
            className="cursor-pointer focus:outline-none"
          >
            <img src={mouUniversal} alt="MEU Aliado" className="h-20" />
          </button>
          <UserPanel />
        </div>
        <div className="flex-1 flex flex-col gap-10 pb-10">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
